import keys from 'lodash-es/keys'
import pickBy from 'lodash-es/pickBy'
import * as Yup from 'yup'

import { PROFILE_ROUTE_NAMES } from '../../../constants/route'
import { isStaffUser } from '../../../utils/user'
import { DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH } from '../Document.constants'

import {
  DOCUMENT_FOLDER_FORM_FIELD_ACCESS_FIELDS,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_NAME,
  DOCUMENT_FOLDER_FORM_INITIAL_VALUES,
  STAFF_DOCUMENT_FOLDER_FORM_INITIAL_VALUES,
} from './DocumentFolderForm.constants'

export function getDocumentFolderValidationSchema(t) {
  return Yup.object({
    [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS]: Yup.object(),
    [DOCUMENT_FOLDER_FORM_FIELD_NAME_NAME]: Yup.string()
      .max(
        DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH,
        t('Error.MaxLengthKey', {
          length: DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH,
        })
      )
      .required(true),
  })
}

export function getDocumentFolderFormPayload({ outboundUuid, parent, values }) {
  return {
    [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS]: outboundUuid
      ? DOCUMENT_FOLDER_FORM_FIELD_ACCESS_FIELDS
      : keys(
          pickBy(
            values[DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS],
            item => item === true
          )
        ),
    [DOCUMENT_FOLDER_FORM_FIELD_NAME_NAME]:
      values[DOCUMENT_FOLDER_FORM_FIELD_NAME_NAME],
    parent,
  }
}

export function getDocumentFolderRoute({ folderId, user }) {
  return isStaffUser(user)
    ? PROFILE_ROUTE_NAMES.folder(folderId)
    : PROFILE_ROUTE_NAMES.folderDweller(folderId)
}

export function getDocumentFolderFormSuccessNotification(
  { id, name },
  { t, to = PROFILE_ROUTE_NAMES.folder(id) }
) {
  return {
    linkProps: {
      reloadDocument: true,
      title: t('Notification.DocumentsFolderCreatedLinkKey'),
      to,
    },
    text: t('Notification.DocumentsFolderCreatedTextKey', {
      name,
    }),
    title: t('Notification.DocumentsFolderCreatedTitleKey'),
  }
}

export function getDocumentFolderFormErrorNotification(t) {
  return {
    text: t('Notification.DocumentsFolderCreationErrorTextKey'),
    title: t('Notification.DocumentsFolderCreationErrorTitleKey'),
  }
}

export function getInitialValues({ user }) {
  return {
    ...(isStaffUser(user)
      ? STAFF_DOCUMENT_FOLDER_FORM_INITIAL_VALUES
      : DOCUMENT_FOLDER_FORM_INITIAL_VALUES),
  }
}
